//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "navSvg",
  computed: {
    active() {
      let result = "0";
      if (this.activeIndex && this.activeIndex != "") {
        result =
          this.activeIndex.indexOf("-") > -1
            ? this.activeIndex.split("-")[0]
            : this.activeIndex;
      }
      return result;
    },
  },
  props: {
    currentIndex: {
      type: String,
      default: "1",
    },
    activeIndex: {
      type: String,
      default: "",
    },
  },
};
